import { render, staticRenderFns } from "./invoice_editor.vue?vue&type=template&id=384c2e2c&scoped=true&"
import script from "./invoice_editor.vue?vue&type=script&lang=js&"
export * from "./invoice_editor.vue?vue&type=script&lang=js&"
import style0 from "./invoice_editor.vue?vue&type=style&index=0&id=384c2e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c2e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384c2e2c')) {
      api.createRecord('384c2e2c', component.options)
    } else {
      api.reload('384c2e2c', component.options)
    }
    module.hot.accept("./invoice_editor.vue?vue&type=template&id=384c2e2c&scoped=true&", function () {
      api.rerender('384c2e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/user_editor/invoice_editor.vue"
export default component.exports